import React, { useState, useEffect } from "react";
import { makeStyles, Grid } from "@material-ui/core";
import CarouselParceirosF from "./CarouselParceirosF";
import api from "../service/api";

export default function Appbar() {
  const classes = useStyles();
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    api
      .get("/sponsors")
      .then((response) => setPartners(Array.isArray(response.data.data) ? response.data.data : []))
      .catch(e => console.log("Erro ao buscar parceiros:", e.message));
  }, []);

  return (
    <div className={classes.root}>
      {partners.length <= 0 ? (
        <Grid
          container
          className={classes.patrocinadores}
          direction="row"
          justifyContent="space-evenly"
          alignItems="center"
        >
          {partners?.map((patrocinador, index) => (
            <Grid key={index} item xs={3}>
              <a href={patrocinador.link} className={classes.link}>
                <img
                  key={patrocinador}
                  src={patrocinador.image_url}
                  alt="Patrocinador"
                  className={classes.img}
                />
              </a>
            </Grid>
          ))}
        </Grid>
      ) : (
        <CarouselParceirosF partners={partners} />
      )}
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100vw",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    boxShadow: "0px 0px 2px #0000009E",
  },
  img: {
    maxWidth: "100%",
    maxHeight: "205px",
    [theme.breakpoints.down("sm")]: {
      maxHeight: "90px",
    },
  },
  patrocinadores: {
    maxWidth: "1366px",
  },
  link: {
    height: "100%",
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
  },
}));
